var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidePanelSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.975 7.00007C13.9868 6.83355 14.0001 6.66849 14.0001 6.50049C14.0001 4.77645 13.3152 3.12303 12.0961 1.90395C10.877 0.684871 9.22362 0 7.49958 0C7.33158 0 7.16653 0.0132633 7 0.0250529V7.00007H13.975Z",
    fill: "#FD6202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99943 7.99846V1.02344C4.36774 1.1482 2.84328 1.88435 1.73096 3.08466C0.618634 4.28497 0.000435435 5.86094 0 7.4974C0 7.66688 0.0132633 7.83193 0.0250529 7.99846C0.14425 9.54333 0.811967 10.9947 1.9076 12.0903C3.00324 13.1859 4.45456 13.8536 5.99943 13.9728C6.16596 13.9846 6.33101 13.9979 6.50049 13.9979C8.13695 13.9975 9.71293 13.3793 10.9132 12.2669C12.1135 11.1546 12.8497 9.63016 12.9745 7.99846H5.99943Z",
    fill: "#1D3679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidePanelSales);
export default __webpack_public_path__ + "static/media/sidePanelSales.41d51d5c5aef0e50f5a93660e0ecbd0f.svg";
export { ForwardRef as ReactComponent };